import { userConstants } from "../../constant";

export function addSponsorshipProductReducer(state = {}, action) {
  switch (action.type) {
    case userConstants.ADD_SPONSORSHIP_PRODUCT:
      return {
        productsList: action.products,
      };
    default:
      return state;
  }
}
